import { render, staticRenderFns } from "./CardStatistics.vue?vue&type=template&id=bc833a1a"
import script from "./CardStatistics.js?vue&type=script&lang=js&external"
export * from "./CardStatistics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports